import React from 'react';
import { Form, Icon, Table } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from 'lodash';
import { ATTRIBUTE_TYPE, ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING } from '../../../../HelperMethods/FormUtils';

import { determineIfUserHasFieldsDisabled } from '../../../../HelperMethods/UserUtilities';
import { ACCESS_OPTIONS, ENTITY_ACCESS_TYPE, RESOURCES } from '../../../../HelperMethods/role-resource-constants';
// eslint-disable-next-line import/no-cycle

import CustomDropdown from '../../../common/CustomDropdown';
import { ReactComponent as IButton } from '../../../../icons/iButton.svg';
import { ReactComponent as IButtonDisabled } from '../../../../icons/iButtonDisabled.svg';
// eslint-disable-next-line import/no-cycle
import { bulkAcceptTaskActionRedux } from './redux/actions';
import { shouldAllowAcceptOrRejectBulkEdit } from './lib/helper';

const filterUsedNames = (formik, assigneeOptions, id) => {
  const ids = _.get(formik, 'values.s_assigneeid', []);
  const options = assigneeOptions.items.filter((item) => {
    if (item.value === id) {
      return true;
    }
    if (ids.includes(item.value)) {
      return false;
    }
    return true;
  });
  return { items: options, isLoading: assigneeOptions.isLoading };
};

const AssigneeComponentBulkEdit = ({ taskTypeOptions, assigneeOptions, formik, task, loggedInUser, ...props }) => {
  const {
    onValueChange: { viewAssigneeDetals, onAssigneeChange },
    selectedTasks,
  } = props;
  const dispatch = useDispatch();
  const [bulkAcceptTaskStatevalue, setbulkAcceptTaskStatevalue] = React.useState(false);

  const assigneeIds = !_.size(_.get(formik, 'values.s_assigneeid'))
    ? ['']
    : _.get(formik, 'values.s_assigneeid') || [''];
  const isSomeTaskLocked = (selectedTasks || []).some((t) => t.isTaskLocked);
  const isSomeTaskEquipmentTask = (selectedTasks || []).some((t) => t?.taskType?.needEquipment);
  const isEveryTaskEquipmentTask = (selectedTasks || []).every((t) => t?.taskType?.needEquipment);

  let equipmentOptions = [];
  let operatorOptions = [];
  let operatorId = '';
  let equipmentId = '';
  if (isEveryTaskEquipmentTask) {
    equipmentOptions = _.get(assigneeOptions, 'items', []).filter((a) => a.originalobject.isEquipmentResource);
    operatorOptions = _.get(assigneeOptions, 'items', []).filter((a) => !a.originalobject.isEquipmentResource);
    if (!equipmentId) {
      const equipmentOptionsDict = _.keyBy(equipmentOptions, 'value');
      equipmentId = assigneeIds.find((id) => equipmentOptionsDict[id]) || '';
      if (equipmentId) {
        const equipmentVendorId = equipmentOptionsDict[equipmentId]?.originalobject?.vendorId;
        if (equipmentVendorId) {
          operatorOptions = operatorOptions.filter((val) => val.originalobject.vendorId === equipmentVendorId);
        }
      }
    }
    if (!operatorId) {
      const operatorOptionsDict = _.keyBy(operatorOptions, 'value');
      operatorId = assigneeIds.find((id) => operatorOptionsDict[id]) || '';
    }
  }

  const handleFieldChange = (data, index) => {
    if (!bulkAcceptTaskStatevalue) {
      const { value, options = [] } = data;
      const assigneeIdsClone = _.cloneDeep(_.get(formik, 'values.s_assigneeid', []));
      if (isEveryTaskEquipmentTask) {
        if (index === 0) {
          assigneeIdsClone[0] = value;
          const equipmentOption = options.find((option) => option.value === value);
          assigneeIdsClone[1] = equipmentOption?.originalobject?.operatorId || ''; // to be prefilled
        } else {
          // const equipmentIdIndex = assigneeIdsClone.findIndex((id) => id === equipmentId);
          const operatorIdIndex = assigneeIdsClone.findIndex((id) => id === operatorId);
          if (operatorIdIndex > -1) {
            assigneeIdsClone[operatorIdIndex] = value;
          }
        }
      } else {
        assigneeIdsClone[index] = value;
      }
      if (index === assigneeIdsClone.length - 1 && !isEveryTaskEquipmentTask) {
        assigneeIdsClone.push('');
      }
      onAssigneeChange({ name: 's_assigneeid', value: assigneeIdsClone, formik });
    }
  };

  const handleDeleteRow = (index) => {
    const assigneeIdsClone = _.cloneDeep(_.get(formik, 'values.s_assigneeid', []));
    assigneeIdsClone.splice(index, 1);

    onAssigneeChange({ name: 's_assigneeid', value: assigneeIdsClone, formik });
  };

  const taskTypeList = useSelector((state) => state.taskTypeReducer.taskTypes);
  const allowAcceptOrRejectBulk = shouldAllowAcceptOrRejectBulkEdit(selectedTasks, taskTypeList);

  const bulkAcceptTask = async () => {
    onAssigneeChange({ name: 's_assigneeid', value: [''], formik });
    setbulkAcceptTaskStatevalue((prevState) => {
      dispatch(bulkAcceptTaskActionRedux(!prevState));
      return !prevState;
    });
    // dispatch(bulkEditPageLoading());

    // if (selectedTasks) {
    //   dispatch(bulkAcceptTaskAction(selectedTasks));

    //   const { assigneeId } = selectedTasks[0].assigneeIds[0];
    //   formik.setFieldValue('s_status', STATUS_LIST.OPEN.key, false);
    //   onAssigneeChange({ name: 's_assigneeid', value: [assigneeId], formik });
    //   for (const taskObj of selectedTasks) {
    //     const taskId = _.get(taskObj, 'id', '');
    //     const reqAssignee = _.get(assigneeOptions, 'items', []).find((a) => a.value === assigneeId);

    //     let assigneeIdTask = '';
    //     if (_.get(taskObj, 'assigneeIds')) {
    //       assigneeIdTask = _.get(_.get(taskObj, 'assigneeIds')[0], 'assigneeId');
    //     }

    //     const data = { taskId, assigneeId: assigneeIdTask };
    //     await ApiService.acceptTask(data);
    //     addComments({ dispatch, reqAssignee, loggedInUser, taskObj, selectedField });
    //     toastr.success('Task Accepted Sucessfully');
    //     setbulkAcceptTaskStatevalue(true);
    //   }
    //   dispatch(stopBulkEditPageLoading());
    // } else {
    //   dispatch(stopBulkEditPageLoading());

    //   toastr.error('No task found');
    //   setbulkAcceptTaskStatevalue(false);
    // }
  };

  return (
    <div style={{ marginTop: '10px', width: `100%` }}>
      {isEveryTaskEquipmentTask && <label>Equipment & Operator</label>}
      {!isSomeTaskEquipmentTask && <label>ASSIGNEES</label>}
      <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'flex-end' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginLeft: '50px',
          }}
        >
          {allowAcceptOrRejectBulk &&
          !determineIfUserHasFieldsDisabled({
            resource: RESOURCES.ENTITY.TASK,
            entityAccessType: ENTITY_ACCESS_TYPE.UPDATE,
            field: ACCESS_OPTIONS.DISABLED_FIELD.options.ACCEPTANCE_STATUS,
            user: loggedInUser,
          })
            ? ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.CHECKBOX]({
                name: 'acceptForAllTasks',
                placeholder: 'Accept selected tasks with single assignee',
                value: bulkAcceptTaskStatevalue,
                onChange: () => {
                  bulkAcceptTask();
                },
              })
            : null}
        </div>
        {isEveryTaskEquipmentTask && (
          <Table id="partsTable">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={3}>Equipment</Table.HeaderCell>
                <Table.HeaderCell width={3}>Operator</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  <Form.Field style={{ height: '50px', display: 'flex' }}>
                    <CustomDropdown
                      placeholder="Choose Equipment"
                      search
                      selection
                      options={{ items: equipmentOptions, isLoading: assigneeOptions.isLoading }}
                      value={equipmentId}
                      onChange={(event, data) => {
                        handleFieldChange(data, 0);
                      }}
                      name="equipmentId"
                      selectOnBlur={false}
                      clearable
                      disabled={isSomeTaskLocked || bulkAcceptTaskStatevalue}
                    />
                    <div
                      className="p-cursor"
                      style={{ margin: '15px 5px 0 5px' }}
                      onClick={equipmentId ? () => viewAssigneeDetals(equipmentId) : null}
                    >
                      {equipmentId ? <IButton /> : <IButtonDisabled />}
                    </div>
                  </Form.Field>
                </Table.Cell>
                <Table.Cell>
                  <Form.Field style={{ height: '50px', display: 'flex' }}>
                    <CustomDropdown
                      placeholder="Choose Operator"
                      search
                      selection
                      options={{ items: operatorOptions, isLoading: assigneeOptions.isLoading }}
                      value={operatorId}
                      onChange={(event, data) => {
                        handleFieldChange(data, 1);
                      }}
                      name="operatorId"
                      selectOnBlur={false}
                      clearable
                      disabled={!equipmentId || isSomeTaskLocked || bulkAcceptTaskStatevalue}
                    />
                    <div
                      className="p-cursor"
                      style={{ margin: '15px 5px 0 5px' }}
                      onClick={operatorId ? () => viewAssigneeDetals(operatorId) : null}
                    >
                      {operatorId ? <IButton /> : <IButtonDisabled />}
                    </div>
                  </Form.Field>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        )}
        {!isSomeTaskEquipmentTask && (
          <Table id="partsTable" style={{ width: '50%' }}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={3}>User</Table.HeaderCell>
                <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            {assigneeIds.map((id, index) => (
              <Table.Body key={index}>
                <Table.Row>
                  <Table.Cell>
                    <Form.Field style={{ height: '50px' }}>
                      <CustomDropdown
                        placeholder="Choose Assignees"
                        search
                        disabled={isSomeTaskLocked || bulkAcceptTaskStatevalue}
                        selection
                        options={filterUsedNames(formik, assigneeOptions, id)}
                        value={id}
                        onChange={(event, data) => {
                          handleFieldChange(data, index);
                        }}
                        name="assigneeid"
                        selectOnBlur={false}
                        clearable
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <div style={{ display: 'flex' }}>
                        <div
                          className="p-cursor"
                          style={{ marginRight: '5px' }}
                          onClick={id ? () => viewAssigneeDetals(id) : null}
                        >
                          {id ? <IButton /> : <IButtonDisabled />}
                        </div>

                        <div
                          onClick={index + 1 === assigneeIds.length ? null : () => handleDeleteRow(index)}
                          className="p-cursor"
                        >
                          <Icon
                            name="trash alternate outline"
                            disabled={isSomeTaskLocked || index + 1 === assigneeIds.length}
                          />
                        </div>
                      </div>
                    </Form.Field>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            ))}
          </Table>
        )}
      </div>
    </div>
  );
};

export default AssigneeComponentBulkEdit;
